import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-toppage__info" }
const _hoisted_2 = { class: "p-toppage__info__wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CMS = _resolveComponent("CMS")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.tab_id === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_CMS, {
              contents_type: "block_contents",
              location_code: "IC_MENUTOP_02_01_003_rankingtitle"
            }),
            _createVNode(_component_CMS, {
              contents_type: "block_contents",
              location_code: "IC_MENUTOP_02_01_004_ranking"
            })
          ], 64))
        : (_ctx.tab_id === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_CMS, {
                contents_type: "block_contents",
                location_code: "IC_MENUTOP_02_02_003_rankingtitle"
              }),
              _createVNode(_component_CMS, {
                contents_type: "block_contents",
                location_code: "IC_MENUTOP_02_02_004_ranking"
              })
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}